import { getRawNeutralPalette } from '../utils/getRawNeutralPalette';
import { getResourcesForTheme } from './getResourcesForTheme';
import { MiniPalette } from '../schema/MiniPalette';
import { store } from '../store/store';

/**
 * Returns the raw color values for various theme symbols. Should only be used if your code
 * needs to manipulate the colors, or apply them outside the current window.
 * @param themeId Theme to get values for. If not provided, defaults to the current theme.
 * @param isDarkTheme If not provided, defaults to the a value based on current theme mode.
 */
export const getRawPalette = (themeId?: string, isDarkTheme?: boolean): MiniPalette => {
    const themeResources = getResourcesForTheme(themeId, isDarkTheme);
    const neutralPalette = getRawNeutralPalette(isDarkTheme);
    return { ...neutralPalette, ...themeResources.themePalette, ...store.customPalette };
};
